import React from "react";
import DvrIcon from "@mui/icons-material/Dvr";
function RecorderConfigsIcon({ iconColor, iconSize = "small", ...other }) {
    return <DvrIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default RecorderConfigsIcon;
